export const parsePrepopulatedTicket = (currentNumber, field) => {
    const thisFieldNumber = currentNumber.slice(0, parseInt(field.size));
    const restOfNumber = currentNumber.slice(parseInt(field.size), currentNumber.length);
    field.value = thisFieldNumber;
    return restOfNumber;
};
